// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "28e6dd27576833748287e33a1a7b6bfe81ab04dc/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};